const baseURLConfig = {
  production: 'https://qadm.qinlinad.com',
  development: '/api-dev',
  // development: 'http://192.168.1.247',
  // testing: 'https://test-qadm.qinlinad.com',
  // 测试服未部署后端，改用正式服接口
  testing: 'https://qadm.qinlinad.com',
  graying: 'https://beta-qadm.qinlinad.com'
}
const baseURL = baseURLConfig[process.env.NODE_ENV]
const config = {
  uploadMaterialImgUrl: baseURL + '/platform/api/v1/upload/material',
  uploadDevicePercentBatchUrl: baseURL + '/platform/api/v1/deviceShare/batchSave',
  getFileUrL: baseURL + '/platform/api/v1/exportVacancy/batchImportVacancy',
  getMaterialFile: baseURL + '/platform/api/v1/material/downLoad'
}
const pointsRules = {
  10: '300,600,900,1200,1500,1800,2100,2400,2700,3000,3300,3600,3900,4200,4500,4800,5100,5400',
  15: '300,600,900,1200,1500,1800,2100,2400,2700,3000,3300,3600',
  20: '300,600,900,1200,1500,1800,2100,2400,2700',
  25: '300,600,900,1200,1500,1800,2100',
  30: '300,600,900,1200,1500,1800',
  35: '300,600,900,1200,1500,1800',
  40: '300,600,900,1200',
  45: '300,600,900,1200',
  50: '300,600,900',
  55: '300,600,900',
  60: '300,600,900'
}
//广告类别positionId对应的广告尺寸
const materialSize = {
  1: { w: 1080, h: 1540 }, //大屏轮播广告
  2: { w: 1080, h: 1540 }, //大屏精准广告
  3: { w: 690, h: 890 }, //开门成功精准弹窗广告
  4: { w: 720, h: 1026 }, //对讲通话广告
  5: { w: 690, h: 890 } //开门成功弹窗广告
}
export { config, pointsRules, baseURL, materialSize }
